import { Injectable, OnDestroy } from "@angular/core";

import { HeaderService } from "../components/header/header.service";
import { Subject, takeUntil } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AgGridRequestService implements OnDestroy {
  account;
  private destroy$ = new Subject<void>();

  constructor(private headerService: HeaderService) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e[0]));
  }

  transformAgGridRequest(
    body,
    columnDefs,
    globalSearch?,
    filters?: {
      [key: string]: {
        filterType: string;
        values?: any;
        type?: string;
        intValues?: number[];
        value?: any;
      };
    },
    sumColumns?,
    isExport?
  ) {
    if (filters) {
      body.filterModel = { ...body.filterModel, ...filters };
    }
    body.globalSearch = globalSearch;
    body.filterModel = this.transformFilters(body.filterModel, columnDefs);
    body.columns = this.getColumns(columnDefs,isExport);
    body.sumColumns = this.getColumns(sumColumns,isExport)
    body.columns = this.getChildColumns(columnDefs,body.columns)  
    return body;
  }

  getColumns(columnDefs,isExport?) {
    return columnDefs?.map((column) => (!column.hide || column?.required || isExport) ? column.backendFields : null)
      .flat()
      .filter((column) => column);
  }

  getChildColumns(columnDefs,columnsArray){
    columnDefs.filter((column)=>{
      if(column?.children?.length){
        column.children.filter((res)=> {
          if(!res.hide || column?.required){
            if(res.backendFields?.length > 0) 
            res.backendFields.forEach((result)=>{
              columnsArray.push(result)
            })
          }
        });
      }
    })    
    return columnsArray;
  }

  transformFilters(filters, columnDefs) {
    const filterModel = {};
    Object.keys(filters).forEach((key) => {
      const filter = filters[key];
      if (filter.filterType === "multi") {
        filter.filterModels.forEach((filter, index) => {
          if (filter) {
            const filterName = this.getFilterName(key, index, columnDefs);
            if (filterName === "modelId") {
              filter = this.convertNumberFilter(filter);
            }
            if (filterName === "Purchased") {
              this.setOrderDate(filter);
            }
            if (filterName === "BB Offer Type") {
              filter.values.forEach((item) => {
                if (item === "FBA") {
                  filterModel["FbaBBPrice"] = {
                    filter: 0,
                    filterType: "number",
                    type: "greaterThan",
                  };
                } else if (item === "FBM") {
                  filterModel["FbmBBPrice"] = {
                    filter: 0,
                    filterType: "number",
                    type: "greaterThan",
                  };
                } else if (item === "Amazon") {
                  filterModel["BBIsAmazon"] = {
                    filterType: "boolean",
                    value: true,
                  };
                }
              });
            } else if (filterName === "PriceModelName") {
              const index = filter.values.indexOf("Unassigned");
              if (index !== -1) {
                filter.values[index] = null;
              }
              filterModel[filterName] = filter;
            } else {
              filterModel[filterName] = filter;
            }
          }
        });
        // filterModel[key] = this.convertMultiFilter(filter, columnDefs, key);
      } else if (filter.filterType === "date") {
        filterModel[key] = this.convertAGgridDate(filter);
      } else {
        filterModel[key] = filters[key];
      }
    });

    return filterModel;
  }

  private getFilterName(parnetFilterName, subFilterIndex, columnDefs) {
    const fieldName = columnDefs.find((column) => {
      return column.field === parnetFilterName;
    }).filterParams.filters[subFilterIndex].title;

    return this.convertName(fieldName);
  }

  private convertName(name, filterValue?) {
    switch (name) {
      case "SKU":
        return "Sku";
      case "ASIN":
        return "Asin";
      case "Min Price":
        return "Minpr";
      case "Max Price":
        return "Maxpr";
      case "Is Repricing":
        return "IsRepricing";
      case "Repricing Model":
        return "PriceModelName";
      case "FBA BB Is Yours":
        return "BBAIsYours";
      case "FBM BB Is Yours":
        return "BBMIsYour";
      case "FBA BB Price":
        return "FbaBBPrice";
      case "FBM BB Price":
        return "FbmBBPrice";
      case "Order ID":
        return "OrderiD";
      case "Order Date":
        return "Purchased";
      case "Vendor Item Name":
        return "VendorItemName";
      case "Item Name":
        return "ItemName";
      case "Profit":
        return "Profit30";
      case "Sales":
        return "SalesAmount";
      case "Qty":
        return "QtySold";
      case "Reorder Alert":
        return "StockTag";
      case "Stock Note":
        return "StockNote";
      case "Title":
        return "Description";
      case "Description":
        return "Title";
        case "Name":
          return "Name";

      case "2D":
        return "2dVelocity";
      case "7D":
        return "7dVelocity";
      case "14D":
        return "14dVelocity";
      case "30D":
        return "30dVelocity";
      case "60D":
        return "60dVelocity";
      case "90D":
      return "90dVelocity";

      case "W1":
        return "Ord7";
      case "W2":
        return "Ord15";
      case "W3":
        return "Ord21";
      case "W4":
        return "Ord30";


      case "Sales 2D":
        return "OrdLast2";
      case "Sales 7D":
        return "OrdLast7";
      case "Sales 14D":
        return "OrdLast14";
      case "Sales 30D":
        return "OrdLast30";
      case "Sales 60D":
        return "OrdLast60";
      case "Sales 90D":
        return "OrdLast90";
      case "Sales 180D":
        return "OrdLast180";
      case "Sales 360D":
        return "OrdLast360";

      case "ShipDate":
        return "shipByDate";
      case "Order Id":
        return "Orderid";
      case "Currency Type":
        return "CurrencyType";
      case "Fulfillment Type":
        return "FulfillmentType";
        case "Batch Id":
          return "batchsId";
          case "WareHouse":
            return "wareHouseName"
            case "Input Value" :
            return "QueueQty"
            case "Suggested Value" :
            return "ReplenishByCase"
            case "Previous Weight" :
              return "PreviousItemPackageWeight"
            case "After Weight" :
              return "ItemPackageWeight"
            case "Previous Height" :
              return "PreviousMedianSide"
            case "After Height" :
              return "MedianSide"
            case "Previous Length" : 
              return "PreviousLongestSide"
            case "After Length" :
              return "LongestSide"
            case "Previous Width" : 
              return "PreviousShortestSide"
            case "After Width" :
              return "ShortestSide"
            case "Margin" : 
            return 'EstimatedMargin'
            case "Markup" : 
            return 'EstimatedMarkup'
            case "Profit" : 
            return 'EstimatedProfitAmount'
             case "Shipment ID" : 
            return 'AmazonShipmentId'
             case "Shipment Name" : 
            return 'ShipmentName'
             case "Total Qty" : 
            return 'TotalQty'
             case "Received Qty" : 
            return 'ReceivedQty'
            case 'Ship From':
              return 'FromWCode'
            case 'Is Primary':
            return 'IsStarred'
              case 'Ship To':
            return 'DestinationWCode'
      default:
        return name;
        break;
    }
  }

  private convertNumberFilter(filter) {
    return filter.values.map((value) => +value);
  }

  private convertAGgridDate(filter) {
    filter.dateFrom = filter.dateFrom
      ? filter.dateFrom.replace(" ", "T")
      : null;
      if(filter.dateTo){
        var date = new Date(filter.dateTo);
        var userTimezoneOffset = date.getTimezoneOffset() * 60000;
        filter.dateTo= new Date(new Date(filter.dateTo).setHours(23,59,59,59) - userTimezoneOffset).toISOString().replace(" ", "T")
      } else{
        filter.dateTo =null;
      }
    return filter;
  }

  private setOrderDate(filter) {
    if(filter.dateTo){
      var date = new Date(filter.dateTo);
      var userTimezoneOffset = date.getTimezoneOffset() * 60000;  
      filter.dateTo= new Date(new Date(filter.dateTo).setHours(23,59,59,59) - userTimezoneOffset).toISOString().replace(" ", "T")   
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}

